import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-19e11264"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "headline text-label-active" }, "Filter shortcuts", -1))
const _hoisted_2 = { class: "widget-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MajorDeviationsWidget = _resolveComponent("MajorDeviationsWidget")!
  const _component_ClosedDeviationsWidget = _resolveComponent("ClosedDeviationsWidget")!
  const _component_MinorDeviationsWidget = _resolveComponent("MinorDeviationsWidget")!
  const _component_HocDeviationsWidget = _resolveComponent("HocDeviationsWidget")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_MajorDeviationsWidget, {
        value: _ctx.input?.majorDeviations,
        period: _ctx.input?.period
      }, null, 8, ["value", "period"]),
      _createVNode(_component_ClosedDeviationsWidget, {
        value: _ctx.input?.closedDeviations,
        period: _ctx.input?.period
      }, null, 8, ["value", "period"]),
      _createVNode(_component_MinorDeviationsWidget, {
        value: _ctx.input?.minorDeviations,
        period: _ctx.input?.period
      }, null, 8, ["value", "period"]),
      _createVNode(_component_HocDeviationsWidget, {
        value: _ctx.input?.hocRatings,
        period: _ctx.input?.period
      }, null, 8, ["value", "period"])
    ])
  ], 64))
}